var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "claim-log row" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 claimlog-functions" }, [
        _c("div", { staticClass: "top-row hidden-xs" }, [
          _c(
            "div",
            { staticClass: "top-left" },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-9" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-group no-borders search-input-group"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchText,
                            expression: "searchText"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "Adjuster, Activity Code, Note content"
                        },
                        domProps: { value: _vm.searchText },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.search.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchText = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-addon" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary search-button",
                            attrs: { type: "button", typeof: "submit" },
                            on: { click: _vm.search }
                          },
                          [
                            _c("i", { staticClass: "fa fa-search" }),
                            _vm._v(" Search\n                                ")
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("filter-options-desktop", { on: { change: _vm.search } })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "claimlog-shortcuts hidden-sm" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "shortcut claimlog-shortcuts__viewDocuments" },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      target: "KEAFilesWindow",
                      href: _vm.$store.state.folderUrl,
                      "data-folder-exists":
                        _vm.$store.state.folderUrl !== "NotFound"
                          ? "true"
                          : "false",
                      "data-folder-archived":
                        _vm.$store.state.folderUrl === "Archived"
                          ? "true"
                          : "false",
                      "data-branch-id": _vm.$store.state.branchId,
                      "data-file-id": _vm.$store.state.fileId
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.handleClick.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-folder" }),
                    _vm._v(" Documents Folder\n                    ")
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "shortcut claimlog-shortcuts__generateReports" },
              [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$refs.reportModal.show()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file" }),
                    _vm._v(" File notes report")
                  ]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "claimlog-functions col-xs-12 hidden visible-xs" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("label", { staticClass: "search-label" }, [
                    _vm._v("Search File Notes:")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchText,
                        expression: "searchText"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Adjuster, Activity Code, Note content"
                    },
                    domProps: { value: _vm.searchText },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.search.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchText = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary search-button",
                      attrs: { type: "button", typeof: "submit" },
                      on: { click: _vm.search }
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" Search\n                        ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-default form-control mobile-filter-button",
                      on: { click: _vm.mobileFilter }
                    },
                    [
                      _c("i", { staticClass: "fa fa-filter" }),
                      _vm._v(
                        "\n                            Filtering Options\n                        "
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row claimlog-results-count" },
          [
            _c(
              "div",
              { staticClass: "hidden-xs" },
              [_c("sort-options-desktop", { on: { change: _vm.search } })],
              1
            ),
            _vm._v(" "),
            _vm.totalPages > 1
              ? _c("pagination", {
                  attrs: { "total-page": _vm.totalPages, align: "center" },
                  on: { change: _vm.setPager },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.claimLog
              ? _c("div", { staticClass: "col-xs-12 text-right" }, [
                  _vm.claimLog.length
                    ? _c("p", [
                        _vm._v(
                          "\n                    Showing " +
                            _vm._s(
                              _vm.options.pageSize * (_vm.currentPage - 1) + 1
                            ) +
                            " to\n                    "
                        ),
                        _vm.currentPage < _vm.totalPages &&
                        _vm.options.pageSize != 10000
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.options.pageSize * _vm.currentPage)
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.claimLog[0].TotalRowCount)
                              )
                            ]),
                        _vm._v(
                          "\n                    of " +
                            _vm._s(_vm.claimLog[0].TotalRowCount) +
                            " entries\n                "
                        )
                      ])
                    : _c("p", [
                        _vm._v(
                          "\n                    No Results Found\n                "
                        )
                      ])
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _vm._l(_vm.claimLog, function(entry, index) {
        return _c(
          "div",
          {
            class: [
              entry.BillingWorksheetId === null ? "" : "invoiced",
              entry.Reversed ? "reversed" : "",
              "item-container"
            ]
          },
          [
            entry.Id !== _vm.$store.state.editId
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
                      _c("h4", {
                        class: [
                          entry.ActivityCode ===
                            _vm.$acConstants("OUT_KILOMETRES_CODE") &&
                          entry.IsNewTransportation
                            ? "activity-code-related"
                            : "activity-code"
                        ],
                        domProps: {
                          innerHTML: _vm._s(_vm.formattedCode[index])
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hidden-xs col-sm-2 invoiced-status text-right"
                      },
                      [_c("invoice-status", { attrs: { entry: entry } })],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  entry.ActivityCode ===
                    _vm.$acConstants("OUT_KILOMETRES_CODE") &&
                  entry.IsNewTransportation
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
                          _c("h4", {
                            staticClass: "activity-code",
                            domProps: {
                              innerHTML: _vm._s(_vm.formattedRelatedCode[index])
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-6 col-sm-4 meta-data" }, [
                      _c("i", { staticClass: "fa fa-calendar" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.formattedDate[index])
                        }
                      }),
                      _vm._v(" "),
                      _vm.formattedTime[index]
                        ? _c("span", [
                            _vm._v(
                              "\n                         " +
                                _vm._s(_vm.formattedTime[index]) +
                                " " +
                                _vm._s(entry.Timezone) +
                                "\n                    "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6 col-sm-4 meta-data" }, [
                      _c("i", { staticClass: "fa fa-user" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.formattedAdjuster[index])
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6 col-sm-4 meta-data" }, [
                      entry.Hours !== 0 &&
                      !(
                        entry.ActivityCode ===
                          _vm.$acConstants("OUT_KILOMETRES_CODE") &&
                        entry.IsNewTransportation
                      )
                        ? _c("span", [
                            _c("i", { staticClass: "fa fa-hourglass" }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(entry.Hours) +
                                " " +
                                _vm._s(entry.ActivityCodeUnits.toLowerCase()) +
                                "\n                    "
                            )
                          ])
                        : entry.Units !== 0
                        ? _c("span", [
                            _c("i", { staticClass: "fa fa-hashtag" }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(entry.Units) +
                                " " +
                                _vm._s(entry.ActivityCodeUnits.toLowerCase()) +
                                "\n                    "
                            )
                          ])
                        : _c("span", [
                            _c("i", {
                              class: [
                                entry.ActivityCodeUnits.toLowerCase() ===
                                "hours"
                                  ? "fa fa-hourglass"
                                  : entry.ActivityCodeUnits.toLowerCase() ===
                                    "units"
                                  ? "fa fa-hashtag"
                                  : "fa fa-dollar-sign"
                              ]
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(entry.Dollars) +
                                " " +
                                _vm._s(entry.ActivityCodeUnits.toLowerCase()) +
                                "\n                    "
                            )
                          ])
                    ])
                  ]),
                  _vm._v(" "),
                  entry.ActivityCode ===
                    _vm.$acConstants("OUT_KILOMETRES_CODE") &&
                  entry.IsNewTransportation
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-offset-8 col-xs-6 col-sm-4 meta-data"
                          },
                          [
                            entry.Hours !== 0
                              ? _c("span", [
                                  _c("i", { staticClass: "fa fa-hourglass" }),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(entry.Hours) +
                                      " " +
                                      _vm._s(
                                        entry.RelatedCodeUnits.toLowerCase()
                                      ) +
                                      "\n                    "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row hidden visible-xs" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 text-center invoiced-status invoiced-status-mobile"
                      },
                      [_c("invoice-status", { attrs: { entry: entry } })],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-md-10" },
                      [
                        _c("h4", { staticClass: "note-re" }, [
                          entry.SendEmail
                            ? _c("span", [_vm._v("Subject:")])
                            : _c("span", [_vm._v("RE:")]),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formattedComment[index])
                            }
                          })
                        ]),
                        _vm._v(" "),
                        entry.InvoiceId ||
                        (entry.SendEmail &&
                          entry.EmailTo &&
                          entry.EmailTo.length)
                          ? _c("div", { staticClass: "email-metadata" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  entry.EmailTo && entry.EmailTo.length
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-3 col-sm-1 label"
                                          },
                                          [_vm._v("To:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-5 col-xs-9" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(entry.EmailTo) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  entry.InvoiceId
                                    ? [
                                        _vm._m(3, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-5 col-xs-9" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(entry.InvoiceId) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              entry.SendEmail ||
                              (entry.ActivityCode === "AR" &&
                                entry.RelatedToTeId != null)
                                ? _c("div", { staticClass: "row" }, [
                                    entry.SendEmail
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-3 col-sm-1 label"
                                          },
                                          [_vm._v("From:")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    entry.SendEmail
                                      ? _c(
                                          "div",
                                          { staticClass: "col-sm-5 col-xs-9" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(entry.EmailFrom) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-xs-3 col-sm-1 label"
                                      },
                                      [_vm._v("Note:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-xs-9" },
                                      [
                                        _c("em", [
                                          _vm._v(
                                            "\n                                    email was sent through KEA \n                                    "
                                          ),
                                          !entry.SendEmail
                                            ? _c("span", [
                                                _vm._v(
                                                  "from another AR TE entry"
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          entry.AttachInvoice
                                            ? _c("span", [
                                                _vm._v("with invoice attached")
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("note-body", {
                          attrs: {
                            "note-text": entry.NoteText,
                            teComment: entry.Comment,
                            collapsible: true,
                            excludeRE: _vm.shouldExcludeRE(entry)
                          }
                        }),
                        _vm._v(" "),
                        entry.TriggerCode && _vm.isAdmin
                          ? _c("div", { staticClass: "trigger-block" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(entry.TriggerCode) +
                                        " - " +
                                        _vm._s(_vm.triggerDescription[index]) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "hidden-xs col-sm-6 trigger-note"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Auto-generated for: " +
                                        _vm._s(entry.ActivityCode) +
                                        " - " +
                                        _vm._s(entry.ActivityCodeDescription) +
                                        "\n                                ("
                                    ),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formattedDate[index]
                                        )
                                      }
                                    }),
                                    _vm._v(
                                      " by " +
                                        _vm._s(entry.UserName) +
                                        ")\n                            "
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-md-2 pull-right" },
                      [
                        _c(
                          "div",
                          { staticClass: "row buttons" },
                          [
                            !entry.Reversed &&
                            (entry.BillingWorksheetId === null ||
                              (entry.BilledDate === null &&
                                entry.ParentWorksheetId === null) ||
                              _vm.fileToBeAudited)
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-6 col-sm-3 col-md-12 text-center"
                                    },
                                    [
                                      entry.Id === _vm.$store.state.lastEditId
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                ref: "lastEditButton",
                                                refInFor: true,
                                                class: [
                                                  "btn",
                                                  "btn-sm",
                                                  "btn-default",
                                                  "form-control",
                                                  entry.Reversed ||
                                                  ((entry.BillingWorksheetId ||
                                                    entry.AdjusterDisabled) &&
                                                    !_vm.fileToBeAudited)
                                                    ? "disabled disable-edit"
                                                    : ""
                                                ],
                                                attrs: {
                                                  "data-teid": entry.Id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editEntry(
                                                      entry,
                                                      _vm.fileToBeAudited
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-edit"
                                                }),
                                                _vm._v(
                                                  "\n                                        Edit\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "button",
                                              {
                                                class: [
                                                  "btn",
                                                  "btn-sm",
                                                  "btn-default",
                                                  "form-control",
                                                  (entry.Reversed ||
                                                    entry.BillingWorksheetId ||
                                                    entry.AdjusterDisabled) &&
                                                  !_vm.fileToBeAudited
                                                    ? "disabled disable-edit"
                                                    : ""
                                                ],
                                                attrs: {
                                                  "data-teid": entry.Id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editEntry(
                                                      entry,
                                                      _vm.fileToBeAudited
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-edit"
                                                }),
                                                _vm._v(
                                                  "\n                                        Edit\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  entry.ActivityCode !=
                                    _vm.$acConstants("EMAIL_REPORT") ||
                                  entry.IsLatestReport
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-6 col-sm-3 col-md-12 text-center"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              class: [
                                                "btn",
                                                "btn-sm",
                                                "btn-default",
                                                "form-control",
                                                entry.Reversed ||
                                                entry.BillingWorksheetId
                                                  ? "disabled"
                                                  : ""
                                              ],
                                              on: {
                                                click: function($event) {
                                                  return _vm.confirmReverse(
                                                    entry.Id,
                                                    entry.ActivityCode,
                                                    entry.ReportNumber
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-undo"
                                              }),
                                              _vm._v(
                                                "\n                                    Reverse\n                                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    entry.ActionItem
                      ? _c(
                          "div",
                          {
                            class: [
                              "col-xs-12",
                              "follow-up-block",
                              entry.FollowupResolved === 1 ? "resolved" : "",
                              ,
                              entry.Reversed ? "reversed" : ""
                            ]
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _vm._m(4, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-2 col-xs-6 text-center"
                                },
                                [
                                  _c("i", { staticClass: "fa fa-calendar" }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.followupDate[index])
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-3 col-xs-6 text-center"
                                },
                                [
                                  _c("i", { staticClass: "fa fa-user" }),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(entry.FollowupFirstName) +
                                      " " +
                                      _vm._s(entry.FollowupLastName) +
                                      " (" +
                                      _vm._s(entry.FollowupAdjuster) +
                                      ")\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-sm-left text-center col-sm-3 followup-action-item"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(entry.ActionItem) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-sm-left text-center col-sm-2 action"
                                },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        id: "resolve" + index,
                                        disabled: entry.Reversed
                                      },
                                      domProps: {
                                        checked: entry.FollowupResolved === 1
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmResolve(
                                            entry.Id,
                                            entry.FollowupResolved === 1
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { attrs: { for: "resolve" + index } },
                                      [_vm._v("Mark as complete")]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  entry.Reversed
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12" }, [
                          _c("h5", [
                            _c("i", { staticClass: "fa fa-undo" }),
                            _vm._v(
                              "\n                        Reversed by\n                        " +
                                _vm._s(entry.ReversedBy) +
                                "\n                        on\n                        "
                            ),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.reversedDate[index])
                              }
                            })
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
              : _c("time-expense-form", { attrs: { reload: _vm.load } })
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.totalPages > 1
        ? _c("pagination", {
            attrs: { "total-page": _vm.totalPages, align: "center" },
            on: { change: _vm.setPager },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { title: "Filtering Options", "ok-text": "Apply" },
          model: {
            value: _vm.showFilterOptions,
            callback: function($$v) {
              _vm.showFilterOptions = $$v
            },
            expression: "showFilterOptions"
          }
        },
        [_c("filter-options-mobile", { on: { change: _vm.search } })],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: { title: "Confirm" },
          on: { hide: _vm.closeReverseModal },
          model: {
            value: _vm.showReverseConfirm,
            callback: function($$v) {
              _vm.showReverseConfirm = $$v
            },
            expression: "showReverseConfirm"
          }
        },
        [
          _c("p", [_vm._v("Reverse this entry?")]),
          _vm._v(" "),
          _vm.reversedActivityCode === _vm.$acConstants("EMAIL_REPORT")
            ? _c("div", [
                _c("p", [_vm._v("This will:")]),
                _vm._v(" "),
                _c("ul", { staticClass: "modal-bullet-list" }, [
                  _c("li", [
                    _vm._v(
                      "Move the Report_" +
                        _vm._s(_vm.reportNumber) +
                        " folder and its contents into the Documents folder"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "Remove report number " +
                        _vm._s(_vm.reportNumber) +
                        " from the database"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Undo the Report Due Date change")])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: { title: "Confirm", size: "sm" },
          on: { hide: _vm.closeResolveModal },
          model: {
            value: _vm.showResolveConfirm,
            callback: function($$v) {
              _vm.showResolveConfirm = $$v
            },
            expression: "showResolveConfirm"
          }
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.isResolved ? "Unresolve" : "Resolve") + " this item?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("report-modal", { ref: "reportModal" })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 hidden-lg hidden-md" }, [
      _c(
        "div",
        {
          staticClass:
            "claimlog-shortcuts-mobile claimlog-shortcuts__newTimeEntry"
        },
        [
          _c("i", { staticClass: "fa fa-plus" }),
          _vm._v(" "),
          _c("a", { attrs: { href: "#/create" } }, [_vm._v("Add T&E Code")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-3 text-right label-fixed-width" }, [
      _c("label", { staticClass: "search-label" }, [
        _vm._v("Search File Notes:")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "shortcut claimlog-shortcuts__newTimeEntry" },
      [
        _c("a", { attrs: { href: "#/create" } }, [
          _c("i", { staticClass: "fa fa-plus" }),
          _vm._v(" Add T&E")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-3 col-sm-1 label" }, [
      _vm._v("Invoice"),
      _c("span", { staticClass: "hidden-xs" }, [_vm._v(" #")]),
      _vm._v(":")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-sm-2 text-sm-left text-center title" },
      [
        _c("i", { staticClass: "fa fa-thumbtack" }),
        _vm._v(
          "\n                            FOLLOWUP\n                        "
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bf6546d", { render: render, staticRenderFns: staticRenderFns })
  }
}